import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const PLATFORMS = { "99food": "99Food", ifood: "iFood", keeta: "Keeta", outra: "Outra" };
export const charLimit = (cfg, platform, occurrence) => {
  const l = cfg?.char_limits?.[platform] || cfg?.char_limits?.["99food"];
  if (!l) return 500;
  return ["cancelamento", "reembolso"].includes(occurrence) ? l.cancel : l.review;
};
export const OCCURRENCES = { avaliacao: "Avaliação negativa", cancelamento: "Cancelamento", reembolso: "Reembolso", resposta: "Resposta ao comentário", outro: "Outro" };
export const SENTIMENTS = { positiva: "Avaliação positiva", negativa: "Avaliação negativa", neutra: "Comentário neutro", mista: "Avaliação mista" };
export const DELIVERY = { parceiro: "Entregador parceiro da plataforma", proprio: "Entregador próprio", retirada: "Retirada pelo cliente" };
export const YESNO = { sim: "Sim", nao: "Não", nao_informado: "Não informado" };
export const EVIDENCE_TYPES = {
  print_avaliacao: "Print da avaliação",
  print_cancelamento: "Print de cancelamento/reembolso",
  foto_pedido: "Foto do pedido preparado",
  foto_lacre: "Embalagem lacrada",
  comanda: "Comanda / comprovante",
  foto_cliente: "Foto enviada pelo cliente",
  entrega: "Registro da entrega",
  outro: "Outro",
};
export const STATUSES = {
  em_analise: "Em análise",
  preparada: "Pronto para enviar",
  enviada: "Enviada",
  aprovada: "Aprovada",
  negada: "Negada",
  aguardando_provas: "Precisa de prova",
};
export const STYLES = {
  mais_forte: "Mais forte",
  mais_tecnico: "Mais técnico",
  mais_objetivo: "Mais objetivo",
  mais_formal: "Mais formal",
  mais_curto: "Mais curto",
  foco_provas: "Foco nas provas",
  foco_entrega: "Foco na responsabilidade da entrega",
};
export const TONES = {
  acolhedor: "Educado e acolhedor",
  profissional: "Profissional",
  firme: "Firme e objetivo",
  defesa: "Defesa da reputação",
  agradecimento: "Agradecimento (positiva)",
};
export const REPLY_TONES = { auto: "Automático", acolhedor: "Educado e acolhedor", profissional: "Profissional", firme: "Firme e objetivo", defesa: "Defesa da reputação", agradecimento: "Agradecimento" };
export const RESPONSIBILITY = { loja: "Loja", entrega: "Entrega", plataforma: "Plataforma", cliente: "Cliente", indeterminada: "Indeterminada" };
export const FINAL_REC = { contestar: "Contestar", reunir_mais_provas: "Reunir mais provas", nao_contestar: "Não contestar" };
export const usageText = (u) => {
  const limit = u?.plan?.analyses_per_month;
  const bonus = u?.bonus_credits ? ` · +${u.bonus_credits} bônus` : "";
  if (!limit) return `${u?.usage ?? 0} análises · ilimitado`;
  return (u.plan.limit_period === "total" ? `${u.usage ?? 0}/${limit} contestações do teste` : `${u.usage ?? 0}/${limit} análises no mês`) + bonus;
};
export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("pt-BR") : "");
export const fmtWhen = (s) => {
  if (!s) return "";
  const d = new Date(s);
  const t = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const days = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(d).setHours(0, 0, 0, 0)) / 86400000);
  if (days === 0) return `Hoje, ${t}`;
  if (days === 1) return `Ontem, ${t}`;
  return `${d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" }).replace(".", "")}, ${t}`;
};
export const caseTitle = (c) => c.title || c.analysis?.titulo || (c.order_number ? `Pedido ${c.order_number}` : OCCURRENCES[c.occurrence_type]);
export const strengthPct = (c) => (c.analysis?.forca != null ? Math.round(c.analysis.forca * 10) : null);
export const strengthLabel = (p) => (p >= 70 ? "Boa base" : p >= 50 ? "Base moderada" : "Base fraca");
